import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getParticipantStatusThunk = createAsyncThunk(
    `GetParticipantStatusSlicer/getParticipantStatusThunk`,
    async ({ login, email }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.get(
            `/Participant/registration/${login}/${email}`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetParticipantStatus: {},
    loadingGetParticipantStatus: false,
    errorGetParticipantStatus: false,
};

const GetParticipantStatusSlicer = createSlice({
    name: 'GetParticipantStatus',
    initialState,
    reducers: {
        resetDataGetParticipantStatus: (state) => {
            state.dataGetParticipantStatus = {};
            state.loadingGetParticipantStatus = false;
            state.errorGetParticipantStatus = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getParticipantStatusThunk.pending, (state) => {
            state.dataGetParticipantStatus = {};
            state.loadingGetParticipantStatus = true;
            state.errorGetParticipantStatus = false;
        });
        builder.addCase(getParticipantStatusThunk.fulfilled, (state, action) => {            
            state.dataGetParticipantStatus = action.payload;
            state.loadingGetParticipantStatus = false;
            state.errorGetParticipantStatus = false;
        });
        builder.addCase(getParticipantStatusThunk.rejected, (state) => {
            state.dataGetParticipantStatus = {};
            state.loadingGetParticipantStatus = false;
            state.errorGetParticipantStatus = true;
        });
    },
});

export const { resetDataGetParticipantStatus } = GetParticipantStatusSlicer.actions;
export default GetParticipantStatusSlicer.reducer;